import React from "react";

import workPassportComplianceProblemSitePositionEvidenceModel from "../../images/work-passport-compliance-problem-site-position-evidence-model.svg";
import workPassportComplianceProblemSitePositionEvidenceModelMobile from "../../images/work-passport-compliance-problem-site-position-evidence-model-mobile.svg";

import "./WorkPassportComplianceProblem.css";

const WORK_PASSPORT_COMPLIANCE_VARIABLES = [
  {
    label: "Site rules change the requirement",
    tone: "site",
  },
  {
    label: "Positions change the evidence needed",
    tone: "position",
  },
  {
    label: "Expiry dates change readiness",
    tone: "expiry",
  },
];

export default function WorkPassportComplianceProblem() {
  return (
    <section
      className="work-passport-compliance-problem"
      id="work-passport-compliance-problem"
      aria-labelledby="work-passport-compliance-problem-title"
    >
      <div className="work-passport-compliance-problem__inner">
        <div className="work-passport-compliance-problem__copy">
          <p className="work-passport-compliance-problem__eyebrow">
            <span aria-hidden="true" />
            The compliance challenge
          </p>

          <h2 id="work-passport-compliance-problem-title">
            Compliance is not one checklist.
          </h2>

          <p className="work-passport-compliance-problem__summary">
            Requirements change by site, position and time. An employee may be
            ready for one assignment, missing critical evidence for another,
            or approaching an expiry that changes readiness.
          </p>

          <ul className="work-passport-compliance-problem__variables">
            {WORK_PASSPORT_COMPLIANCE_VARIABLES.map((item) => (
              <li
                key={item.label}
                className={`work-passport-compliance-problem__variable work-passport-compliance-problem__variable--${item.tone}`}
              >
                <i aria-hidden="true" />
                {item.label}
              </li>
            ))}
          </ul>

          <p className="work-passport-compliance-problem__closing">
            Manual records often reveal the gap only when work is already at
            risk.
          </p>
        </div>

        <picture className="work-passport-compliance-problem__visual">
          <source
            media="(max-width: 620px)"
            srcSet={workPassportComplianceProblemSitePositionEvidenceModelMobile}
          />
          <img
            src={workPassportComplianceProblemSitePositionEvidenceModel}
            alt="Site, position and employee evidence combining to produce a live readiness result"
          />
        </picture>
      </div>
    </section>
  );
}
